import React, { useEffect, useState } from "react";
import "./WorkFlowRequestOverviewCard.scss";
import { INIT_WORKFLOW_STAGE, WorkFlowStage } from "../../models/Workflow";
import { Handle, Position } from "reactflow";
import {
  IWorkFlowRequestStage,
  WORKFLOW_REQUEST_STAGE_STATUS,
} from "../../models/WorkflowRequest";
import { useWorkFlowContext } from "../../context/workflow-context";

interface WorkFlowRequestOverviewCardProps {
  data: IWorkFlowRequestStage;
  isConnectable: boolean;
}

const WorkFlowRequestOverviewCard: React.FC<
  WorkFlowRequestOverviewCardProps
> = ({ data, isConnectable }) => {
  const { setSelectedNode } = useWorkFlowContext();

  const openStageDetails = (id: number) => {
    console.log("Stage clickec: ", id);
    if (setSelectedNode) {
      setSelectedNode(id);
    }
  };
  return (
    <>
      <div
        className={`workflow-overview-card-main-container p-12 flex-column justify-content-space-between wfr-overview-${data.status
          .toLowerCase()
          .split(" ")
          .join("-")}`}
        onClick={() => openStageDetails(data.stage_id)}
      >
        <p
          className={`status flex-row justify-content-center align-items-center px-12 py-6 xetgo-font-tag bold ${
            data.status === WORKFLOW_REQUEST_STAGE_STATUS.ON_HOLD
              ? "on-hold-status"
              : data.status == WORKFLOW_REQUEST_STAGE_STATUS.YET_TO_START
                ? "to-start"
                : data.status == WORKFLOW_REQUEST_STAGE_STATUS.COMPLETED
                  ? "completed"
                  : data.status == WORKFLOW_REQUEST_STAGE_STATUS.IN_PROGRESS
                    ? "in-progress"
                    : "overdue"
          }`}
        >
          {data.status}
        </p>
        <p className="title bolder xetgo-font-button">{data.title}</p>
        <div className="flex-row gap-8 align-items-center">
          <img
            height={16}
            width={16}
            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241122103512-Icon.svg"
            alt="users-icon"
          />
          <p className="team-count  xetgo-font-tag">{data.team?.name}</p>
        </div>
        <div className="sla-days flex-row gap-8 align-items-center">
          <img
            height={16}
            width={16}
            src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250228064659-calendar-days.svg"
            alt="calendar-icon"
          />
          {data.status === "Overdue" ? (
            <p className="team-count  xetgo-font-tag">{data.due_date}</p>
          ) : data.sla ? (
            <p className="team-count  xetgo-font-tag">SLA - {data.sla} Days</p>
          ) : (
            <p className="xetgo-font-tag flex-row align-items-center gap-4">
              <span>Not set</span> <span className="dot p-1"></span>
              <span>{data.active_days} active</span>
            </p>
          )}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Left}
        id="a"
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
        className="hidden-handle"
      />
      <Handle
        type="source"
        position={Position.Right}
        id="b"
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
        className="hidden-handle"
      />
      <Handle
        type="source"
        position={Position.Top}
        id="c"
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
        className="hidden-handle"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="d"
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
        className="hidden-handle"
      />
    </>
  );
};

export default WorkFlowRequestOverviewCard;
